import { journalsServiceApi } from "@entities/api";

interface IUpdateSectionFourRecordSigned {
  sectionFourListId: string;
  versionId: string;
  itemPartOneId: string;
  updateRequest: {
    mainJournalId: string;
    section4Id: string;
    section4ListId: string;
    itemNoVersionId: string;
    companyId?: string;
    itemPartOne?: {
      isDefects?: boolean;
      constructionControlInfo: string;
      controlEventPeriod?: {
        beginDate?: string;
        endDate?: string;
      };
      defectFixingPlanDate?: string;
      defectDescriptionText?: string;
      defectsAbsenceRecord?: string;
      updateDocs?: Array<any>;
      structuralElementName?: string;
      locationDescription?: string;
      locationType?: string;
      updateWorks?: Array<any>;
      createOtherDocs?: Array<any>;
      deleteOtherDocs?: Array<{ file: { id: string; fileId: string } }>;
      inspectionEmployeeId: string;
      actionDetails: string;
    };
  };
}

export async function updateSectionFourRecordSigned({
  sectionFourListId,
  versionId,
  itemPartOneId,
  updateRequest,
}: IUpdateSectionFourRecordSigned) {
  const formData = new FormData();

  const jsonBlob = new Blob([JSON.stringify(updateRequest)], {
    type: "application/json",
  });

  formData.append("updateRequest", jsonBlob);

  updateRequest.itemPartOne?.createOtherDocs?.forEach((doc: any) => {
    if (doc.file instanceof File || doc.file instanceof Blob) {
      formData.append("otherFiles", doc.file);
    }
  });
  const token = localStorage.getItem("token");

  const res = await journalsServiceApi.putForm(
    `/journals/section-four/${sectionFourListId}/items/${versionId}/itemPartOne/${itemPartOneId}/update`,
    formData,
    {
      headers: {
        "X-Auth": token || "",
      },
    },
  );

  return res.data;
}

